module.exports = {
  "id": "da0d2494-38b3-42ec-89c5-ad773f53047a",
  "gtmIds": [
    "GTM-5F9DZ99B",
    "GTM-W22MFQX9"
  ],
  "startTracking": "since_launch",
  "hasInAppVersion": false,
  "group": "Lutsen Mountains",
  "language": "en-US",
  "defaultDateFormat": {
    "id": 2,
    "format": "MM/DD/YYYY",
    "name": "Numeric Month First (04/23/2026)"
  },
  "defaultNumberFormat": {
    "id": 1,
    "name": "English (Comma thousands, Dot decimals)",
    "format": "#,###.##"
  },
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://lutsen-mountains-prod.spotliowebsites.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}